export const MIN_RESULTS_CACHE_TTL_SECONDS = 60;
export const MAX_RESULTS_CACHE_TTL_SECONDS = 30 * 24 * 60 * 60;
//# sourceMappingURL=resultsCacheProjectSettings.js.map